import { render, staticRenderFns } from "./detail_v1.vue?vue&type=template&id=3cac64d2&scoped=true&"
import script from "./detail_v1.vue?vue&type=script&lang=js&"
export * from "./detail_v1.vue?vue&type=script&lang=js&"
import style0 from "./detail_v1.vue?vue&type=style&index=0&id=3cac64d2&scoped=true&lang=css&"
import style1 from "./detail_v1.vue?vue&type=style&index=1&id=3cac64d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cac64d2",
  null
  
)

export default component.exports